/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import RolesFilterBarV2 from "components/roles/filter-bar";
import Loader from "components/PageLoader";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { useGetRolesPaginated } from "../../services/auth-api";
import { HasPermission } from "../../utils/helper";
import { initialDataState } from "./constants";

export default function RolesFollowUp() {
  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);

  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 25;

  const [filters, setFilters] = useState({
    searchCriteria: "",
  });
  const {
    mutate: getRoles,
    data: rolesList,
    isPending: gettingRolesList,
    // error: rolesListError,
  } = useGetRolesPaginated();

  useEffect(() => {
    setCurrentPage(1);
    getRoles({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
    });
  }, [filters]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getRoles({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
    });
  };
  const viewUserCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Link
            to={`${Paths.roleDetails}/${dataItem.name.split(" ").join("_")}`}
            style={{ color: "blue" }}
          >
            {dataItem.name}
          </Link>
        ) : (
          <> {dataItem.userName}</>
        )}
      </td>
    );
  };
  const editCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editRole}/${dataItem.name.split(" ").join("_")}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Role", "Edit");
  }, [user]);
  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Role", "View");
  }, [user]);
  return (
    <Flex className="main-container">
      {gettingRolesList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <RolesFilterBarV2
            getList={(filter) => {
              setFilters({
                searchCriteria: filter,
              });
            }}
          />
          <Grid
            data={process(rolesList?.data.data || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={rolesList?.data.totalRecords || 0}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column field="name" title="Role" cell={viewUserCell} />
            <Column field="description" title="Description" />
            {/* <Column field="usersCount" title="Users Count" headerClassName={"text-center"} className="text-center" /> */}
            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editCell}
              />
            ) : (
              <></>
            )}

            {/* <Column width="100" title="Actions" className="text-center" filterable={false} cell={EditButtonCell} /> */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
